import { AppStore, RootState } from "@/redux/store";
import { selectRouterId, selectUsername } from "@/features/auth/authSlice";

import axiosInstance from "./api";

let store: AppStore;

export const injectStore = (_store: AppStore) => {
  store = _store;
};

axiosInstance.interceptors.request.use(
  (config) => {
    const state: RootState = store.getState();
    const routerId = selectRouterId(state);
    const username = selectUsername(state);

    config.data = {
      ...config.data,
      router_id: config.data.router_id || routerId,
      userid: config.data.userid || username,
    };

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

